import { Control, FieldPath, FieldValues, useWatch } from 'react-hook-form';
import { FormCounter } from './FormCounter';

interface HookFormCounterProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  maxLength: number;
  name: FieldPath<TFieldValues>;
}

export function HookFormCounter<TFieldValues extends FieldValues>({
  control,
  maxLength,
  name,
}: HookFormCounterProps<TFieldValues>) {
  const value = useWatch({ control, name });

  return (
    <FormCounter
      length={typeof value === 'string' ? value.length : 0}
      maxLength={maxLength}
    />
  );
}
